import type {AxiosInstance} from 'axios';
import {COOKIE_VALUE, ENDPOINTS} from 'general/constants';
import {getEmailFromLocalStorage} from 'general/libs/getEmailFromLocalStorage';
import {getCookie} from 'general/libs/getCookie';
import {setCookie} from 'general/libs/setCookie';
import {logWithSentry} from 'sentry/sentry';
import {isLoggedInViaGoogle} from 'general/libs/isLoggedInViaGoogle';

type NewsLetterStatusResponseType = {
    type: string;
    isSubscribed: boolean;
    isEmailSubscribed: boolean;
    isSmsSubscribed: boolean;
};

const updateEmailSubscriberCookie = (isSubscribed: boolean) => {
    if (isSubscribed) {
        setCookie(COOKIE_VALUE.SUBSCRIBER, 'true', 1);
    } else {
        //removes cookie
        setCookie(COOKIE_VALUE.SUBSCRIBER, 'true', 0);
    }
};

export const getIsUserSubscribed = async (instance: AxiosInstance): Promise<string | void> => {
    if (isLoggedInViaGoogle()) {
        updateEmailSubscriberCookie(true);
        return;
    }

    const email = getEmailFromLocalStorage();
    if (!email) {
        updateEmailSubscriberCookie(false);
        return;
    }

    if (getCookie(COOKIE_VALUE.SUBSCRIBER_CHECK)) return;

    try {
        const {
            data: {isEmailSubscribed, isSmsSubscribed},
        } = await instance.post<NewsLetterStatusResponseType>(ENDPOINTS.GET_IS_USER_SUBSCRIBED, {
            destination: email,
        });

        updateEmailSubscriberCookie(isEmailSubscribed || isSmsSubscribed);
        setCookie(COOKIE_VALUE.SUBSCRIBER_CHECK, 'true', 1);
    } catch (e) {
        logWithSentry(e as Error);
    }
};
